<template>
  <el-row>
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="待处理"
                   name="cur"></el-tab-pane>
      <el-tab-pane label="已处理"
                   name="his"></el-tab-pane>
    </el-tabs>

    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="员工姓名:"
                      prop="employee_name">
          <el-input v-model.trim="searchForm.employee_name"
                    placeholder="员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="员工卡号:"
                      prop="employee_id">
          <el-input v-model.trim="searchForm.employee_id"
                    placeholder="员工卡号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>

    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                :cell-class-name="cellClassName"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         :label="(activeName === 'cur' ? '操作':'完成时间')"
                         :width="(activeName === 'cur' ? '100':'160')">
          <template slot-scope="scope">
            <el-button v-has="'/tenement/done'"
                       v-if="(scope.row.auth_need_stat === scope.row.lock_auth_stat) && (activeName === 'cur')"
                       size="mini"
                       type="primary"
                       @click="handleDone(scope.row)">完成</el-button>
            <el-link class="mr-5"
                     v-if="activeName === 'his'"
                     :underline="false"
                     type='primary'>{{scope.row.oper_time}} </el-link>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import Pagination from '@/components/pagination/Pagination'

export default {
  components: { Pagination },
  data() {
    return {
      activeName: 'cur',
      countDown: false,
      timer: 45,
      timeObj: null,
      randomNum: '',
      authId: localStorage.getItem('token'),
      areaList: [],
      depList: [],
      searchForm: {
        employee_name: '',
        employee_id: ''
      },
      tableTitle: [
        {
          prop: 'operation_type',
          name: '操作类型',
          width: '100'
        },
        {
          prop: 'employee_name',
          name: '员工姓名',
          width: '100'
        },
        {
          prop: 'employee_id',
          name: '员工卡号',
          width: '160'
        },
        {
          prop: 'employee_card_id',
          name: '工卡ID号',
          width: '100'
        },
        {
          prop: 'employee_card_ic',
          name: '工卡IC号',
          width: '100'
        },
        {
          prop: 'house_id',
          name: '房屋ID',
          width: '180'
        },
        {
          prop: 'community',
          name: '小区',
          width: '200'
        },
        {
          prop: 'building',
          name: '楼号',
          width: '100'
        },
        {
          prop: 'unit',
          name: '单元',
          width: '100'
        },
        {
          prop: 'room',
          name: '房间',
          width: '180'
        },
        {
          prop: 'lock_name',
          name: '设备',
          width: '180'
        },
        {
          prop: 'valid_from',
          name: '起始日期',
          width: '100'
        },
        {
          prop: 'valid_to',
          name: '腾退日期',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    cellClassName({ row, column }) {
      if (this.activeName === 'his') return ''
      // 根据列字段和行数据返回对应的样式类名
      if (column.property === 'house_id') {
        if (row.house_id_stat != 1) return 'red-text'
      }
      if (column.property === 'employee_id') {
        if (row.employee_id_stat != 1) return 'red-text'
      }
      if (column.property === 'operation_type') {
        if (row.auth_need_stat != row.lock_auth_stat) return 'red-text'
      }
      //if (column.property === 'valid_from') {
      //  if (row.valid_from_stat != 1) return 'red-text'
      //}
      //if (column.property === 'valid_to') {
      //  if (row.valid_to_stat != 1) return 'red-text'
      //}
      return ''
    },
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      const { searchForm } = this

      let datas = {
        employee_name: searchForm.employee_name,
        employee_id: searchForm.employee_id
      }
      fetch
        .getTentManage({
          syn_status: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...datas
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.vist_sex = item.vist_sex === '1' ? '男' : item.vist_sex === '2' ? '女' : '未知'
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    //选项卡切换
    handleClick() {
      this.pagination.currentPage = 1
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.searchForm.begin_time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 操作完成
    handleDone(data) {
      this.$confirm('确定此授权任务已经全部操作完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.doneTentManage({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style>
.red-text {
  background-color: rgba(245, 108, 108, 0.2);
  color: red;
}

.green-text {
  background-color: burlywood;
  color: green;
}

.blue-text {
  background-color: burlywood;
  color: blue;
}
</style>
